// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Emotion from "../../bindings/Emotion.bs.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as JsxRuntime from "react/jsx-runtime";

function Avatar$Avatar(props) {
  let __className = props.className;
  let __size = props.size;
  let src = props.src;
  let name = props.name;
  let size = __size !== undefined ? __size : "md";
  let className = __className !== undefined ? __className : "";
  let dimension = size === "md" ? "2.5rem" : (
      size === "sm" ? "2rem" : "3.5rem"
    );
  let fontSize = size === "md" ? "0.875rem" : (
      size === "sm" ? "0.75rem" : "1.125rem"
    );
  let baseStyles = Emotion.Css.css({
    width: dimension,
    height: dimension,
    borderRadius: "50%",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: "0",
    overflow: "hidden",
    backgroundColor: Emotion.Utils.Color.bgElevated,
    border: `1px solid ` + Emotion.Utils.Color.border,
    color: Emotion.Utils.Color.textSecondary,
    fontSize: fontSize,
    fontWeight: "500",
    letterSpacing: "0.05em",
    textTransform: "uppercase"
  });
  let imgStyles = Emotion.Css.css({
    width: "100%",
    height: "100%",
    objectFit: "cover"
  });
  let initials = Stdlib_Array.filterMap(name.split(" "), part => part.charAt(0)).slice(0, 2).join("");
  let avatarClassName = Emotion.Css.cx([
    baseStyles,
    className
  ]);
  return JsxRuntime.jsx("div", {
    children: src !== undefined ? JsxRuntime.jsx("img", {
        className: imgStyles,
        alt: name,
        src: src
      }) : initials,
    className: avatarClassName
  });
}

let Avatar = {
  make: Avatar$Avatar
};

export {
  Avatar,
}
/* Emotion Not a pure module */
